import React, {Component} from 'react';

import { Theme } from '@mui/material/styles';
import { withStyles } from '@mui/styles';
import Paper from '@mui/material/Paper';
import LoginForm from './LoginForm';
import LoginFooter from './LoginFooter';
import LoginCarousel from './LoginCarousel';
import { CenterGrid } from '../layout';
import { apipost, bizpost } from '../../ajax';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';

const styles = (theme:Theme):any => ({
  rootbox:{
    position: 'relative',
    height: '100vh',
  },
  gridbox: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)'
  },
  main: {
    display: 'flex',
    justifyContent: 'center',
    backgroundColor:theme.palette.primary.main,
    borderRadius: 15,
  },
});
  
class CustomFormMain extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);

    this.state = {
      count: 0,
      loading: true,
      customertypes: null,
      idtypes:null
    };
  }

  async componentDidMount() {

    try {
      this.setState({ loading: true });
      // Replace '/api/init' and params with your actual endpoint and payload
      let s = 'customertype';
      let a = 'combo';
      //let recs = (mode==='delete')?{rid:+(record.rid),stp:record.stp}:record;
      //console.log('service data ',service,mode,record,formdata);
      let params = {module:'customertype'};
      let idTypeParams = {module:'idtype'};
      const url = '/app/publiclookup';
      //const customertyperes = await apipost(customertypeurl,'',params);

      const values = await Promise.all([apipost(url,'',params),apipost(url,'',idTypeParams)])
      if(values[0]?.success!==true) this.setState({customertypes:[]});
      if(values[1]?.success!==true) this.setState({idtypes:[]});

      this.setState({ customertypes: values[0]?.data?.sd});
      this.setState({idtypes:values[1]?.data?.sd});
     
    } catch (error) {
      console.error('API fetch failed:', error);
    }finally{
      this.setState({ loading: false });
    }
  }


  render() {
    const {home,apptheme,logincontext,onMessage,classes,onLogin} = this.props;
    const { loading, customertypes,idtypes } = this.state;

    if (loading) {
      return (
        <div className={classes.rootbox}>
          <div className={classes.gridbox}>
            <CenterGrid>
              <Paper elevation={3} square={false} className={classes.main} style={{padding: 40, textAlign: 'center'}}>
                <CircularProgress color="secondary" size={48} />
                <Typography variant="h6" style={{marginTop: 20, color: '#555'}}>
                  Loading form, please wait...
                </Typography>
              </Paper>
            </CenterGrid>
          </div>
        </div>
      );
    }

    //console.log('apiData ',apiData);

    return (
      <div className={classes.rootbox}>
        <div className={classes.gridbox}>
          <CenterGrid>
            <Paper elevation={3} square={false} className={classes.main}>
              <LoginForm home={home} apptheme={apptheme} logincontext={logincontext} onMessage={onMessage} onLogin={onLogin} data={{idtypes,customertypes}}/>
            </Paper>
            <LoginFooter home={home} apptheme={apptheme} onMessage={onMessage} />
          </CenterGrid>
        </div>
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(CustomFormMain);
